// extracted by mini-css-extract-plugin
module.exports = {"Files":"sert_Files__mc8LQ","File":"sert_File__MDcDw","Name":"sert_Name__ZMcnU","SertLanding":"sert_SertLanding__6DaEm"};